import React from 'react';

export const FormativeAssessmentSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_18689_2440)">
      <path
        d="M16.9059 7.72884C16.6902 7.72884 16.5153 7.55396 16.5153 7.33821C16.5153 5.21337 14.7866 3.48466 12.6617 3.48466C11.2902 3.48466 10.011 4.22306 9.32331 5.41173C9.21526 5.59849 8.97632 5.66231 8.78956 5.55423C8.60284 5.44618 8.53901 5.20724 8.64706 5.02048C9.47393 3.59126 11.0123 2.70337 12.6617 2.70337C15.2174 2.70337 17.2965 4.78255 17.2965 7.33817C17.2965 7.55395 17.1216 7.72884 16.9059 7.72884Z"
        fill="currentColor"
      />
      <path
        d="M8.985 5.60683C8.88773 5.60683 8.79371 5.57051 8.72156 5.50461C8.64507 5.43473 8.59949 5.33734 8.5948 5.23383L8.5182 3.53785C8.50843 3.32234 8.67527 3.13972 8.89082 3.13C9.10613 3.12086 9.28894 3.28707 9.29867 3.50262L9.35765 4.80832L10.6634 4.74933C10.8785 4.73984 11.0614 4.9064 11.0712 5.12191C11.0809 5.33746 10.9141 5.52004 10.6986 5.52976L9.00265 5.6064C8.99675 5.60668 8.99086 5.60683 8.985 5.60683Z"
        fill="currentColor"
      />
      <path
        d="M12.6617 11.973C10.106 11.973 8.02689 9.8938 8.02689 7.33813C8.02689 7.12239 8.20177 6.94751 8.41751 6.94751C8.63325 6.94751 8.80814 7.12239 8.80814 7.33813C8.80814 9.46302 10.5368 11.1917 12.6617 11.1917C14.0332 11.1917 15.3124 10.4533 16.0002 9.26462C16.1082 9.0779 16.3471 9.01403 16.5339 9.12212C16.7206 9.23017 16.7844 9.46911 16.6763 9.65587C15.8494 11.0851 14.3111 11.973 12.6617 11.973Z"
        fill="currentColor"
      />
      <path
        d="M16.4147 11.5466C16.2071 11.5466 16.0342 11.3831 16.0248 11.1736L15.9658 9.86786L14.66 9.92685C14.4451 9.93626 14.2619 9.76978 14.2522 9.55423C14.2424 9.33872 14.4092 9.1561 14.6248 9.14638L16.3208 9.06974C16.4247 9.06505 16.5254 9.10169 16.6019 9.17157C16.6783 9.24145 16.7239 9.33884 16.7286 9.44235L16.8052 11.1383C16.8149 11.3538 16.6482 11.5364 16.4326 11.5461C16.4266 11.5465 16.4206 11.5466 16.4147 11.5466Z"
        fill="currentColor"
      />
      <path
        d="M12.6617 14.6766C8.61538 14.6766 5.32343 11.3846 5.32343 7.33828C5.32343 3.29191 8.61534 0 12.6617 0C16.7081 0 20 3.29191 20 7.33828C20 11.3846 16.7081 14.6766 12.6617 14.6766ZM12.6617 0.78125C9.04616 0.78125 6.10468 3.72273 6.10468 7.33828C6.10468 10.9538 9.04616 13.8953 12.6617 13.8953C16.2773 13.8953 19.2187 10.9538 19.2187 7.33828C19.2187 3.72273 16.2773 0.78125 12.6617 0.78125Z"
        fill="currentColor"
      />
      <path
        d="M1.34686 19.9994C1.00194 19.9994 0.657057 19.8681 0.394479 19.6055C-0.130638 19.0804 -0.130638 18.2259 0.394479 17.7007L4.28112 13.8141C4.43366 13.6616 4.681 13.6616 4.83358 13.8141L6.18592 15.1664C6.33846 15.319 6.33846 15.5663 6.18592 15.7189L2.29928 19.6055C2.03667 19.8681 1.69178 19.9994 1.34686 19.9994ZM0.946901 19.0531C1.16745 19.2737 1.52628 19.2737 1.74686 19.0531L5.35729 15.4427L4.55737 14.6428L0.94694 18.2532C0.726393 18.4737 0.726393 18.8326 0.946901 19.0531Z"
        fill="currentColor"
      />
      <path
        d="M5.23357 15.1571C5.13357 15.1571 5.03365 15.1189 4.95736 15.0427C4.80482 14.8901 4.80482 14.6428 4.95736 14.4902L7.4726 11.975C7.62517 11.8225 7.87248 11.8225 8.02506 11.975C8.1776 12.1275 8.1776 12.3748 8.02506 12.5274L5.50982 15.0427C5.43353 15.1189 5.33353 15.1571 5.23357 15.1571Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default FormativeAssessmentSvg;
